'use client';

import { ProductPage } from '@/components/pages';
import usePrepareProductStoreTable from '@/hooks/_product/usePrepareProductStoreTable';
import usePrepareProductVendorTable from '@/hooks/_product/usePrepareProductVendorTable';
import { activeUserState } from '@/redux-toolkit/auth/auth.slice';
import { useAppSelector } from '@/redux-toolkit/hooks';
import { EnumRole } from '@/types/constants';

const Product = () => {
  const userState = useAppSelector(activeUserState);
  const {
    dataDesktop: vendorDesktopData,
    dataMobile: vendorMobileData,
    pageSize: vendorPageSize,
    totalCount: vendorTotalCount,
  } = usePrepareProductVendorTable();
  const {
    dataDesktop: storeDesktopData,
    dataMobile: storeMobileData,
    pageSize: storePageSize,
    totalCount: storeTotalCount,
  } = usePrepareProductStoreTable();

  if (userState?.role === EnumRole.VENDOR) {
    return (
      <ProductPage
        dataDesktop={vendorDesktopData}
        dataMobile={vendorMobileData}
        pageSize={vendorPageSize}
        totalCount={vendorTotalCount}
      />
    );
  }
  if (userState?.role === EnumRole.STORE) {
    return (
      <ProductPage
        dataDesktop={storeDesktopData}
        dataMobile={storeMobileData}
        pageSize={storePageSize}
        totalCount={storeTotalCount}
      />
    );
  }
  return null;
};

export default Product;
